
<div class="checkbox">
  <input :id="name" v-model="localValue" type="checkbox" />
  <label :for="name"><slot /></label>
</div>
